import React from "react"
import DodoablesListItem from 'app/dodoables/list/Item'

export default ({ dodoables }) => {
  return <div className="fcol flex-1">
           <div className="fcol flex-1" style={{ overflowY: 'scroll' }}>
             {
               dodoables.map((dodoable) => {
                 return <DodoablesListItem key={ dodoable.id } dodoable={ dodoable } />
               })
             }
           </div>
         </div>;
};
